// extracted by mini-css-extract-plugin
export default {"wrapper":"fP9lMG_a7JX_4qhCw94e","button":"UMcC2c3YdijsxYa0E800","active":"bHqKU2wHh8kgtj5Wb72A","title":"ZbjXBlQDwKtObXgGIde9"};